import React from 'react';
import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';

export const DownloadButton = ({ onClick, title, tooltip }) => {
    const { t } = useTranslation();

    return (
        <button className={'button--main success-button'}
                onClick={onClick}
                title={tooltip}>
            {t('common:buttons.download') + ' ' + title}
        </button>
    );
};